// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

var ReconciliationAssignController = function ($scope, $routeParams, $location, ReconciliationAssign, ReconciliationAssignSearch, Reconciliation, SharedParameters, PUtill) {
    var clearSelection = function () {
        $scope.choosenContract = '';
        $scope.choosenLedgers = [];
        $scope.choosenLedgersAmount = 0;
        $scope.choosenLedgersCount = 0;
    };
    
    clearSelection();
    $scope.wasSearching = false;
    $scope.isAscending = true;

    let getTransaction = function () {
        ReconciliationAssign.get({ transactionId: $routeParams.transactionId }, function (data) {
            $scope.transaction = data;
            $scope.RemainingAmount = $scope.transaction.RemainingAmount;
            $scope.SelectedAmount = $scope.RemainingAmount;
        });
    };
    getTransaction();

    $scope.updateFilter = function () {
        clearSelection();
        ReconciliationAssignSearch.query({ searchValue: $scope.search, transactionId: $routeParams.transactionId }, function (data) {
            $scope.items = data;
            $scope.wasSearching = true;
        });
    };
    
    $scope.clearFilter = function () {
        $scope.search = '';
        $scope.updateFilter();
    };
    
    $scope.unassign = function (item) {
        if (item.processing) return;
        item.processing=true;
        
        ReconciliationAssign.delete({ transactionId: $scope.transaction.Id, ledgerEntryId: item.LedgerEntryId }, function (data) {
            $scope.transaction = data;
            $scope.RemainingAmount = $scope.transaction.RemainingAmount;
            $scope.SelectedAmount = $scope.RemainingAmount;
            $scope.updateFilter();
            getTransaction();
        });
    };

    $scope.isAmountValid = function () {
        if ($scope.SelectedAmount || $scope.SelectedAmount === 0 && $scope.RemainingAmount || $scope.RemainingAmount === 0) {
            return $scope.RemainingAmount > 0
                ? $scope.SelectedAmount <= $scope.RemainingAmount && $scope.SelectedAmount > 0
                : $scope.SelectedAmount >= $scope.RemainingAmount && $scope.SelectedAmount < 0;
        }
        return true;
    };

    $scope.isAssignActionAvailable = function () {
        if ($scope.SelectedAmount) {
            return $scope.isAmountValid() && ($scope.choosenContract || $scope.choosenLedgersCount > 0) && Math.abs($scope.SelectedAmount) > 0;
        }
        return false;
    };

    $scope.assign = function () {
        if (!$scope.isAssignActionAvailable()) {
            $scope.showErrorBox("Assign action is not available: Ledger is not selected or amount is not valid!");
            return;
        }

        function convertDictionaryToArray(dict) {
            return Object.keys(dict)
                .filter(function (key) { return dict[key]; })
                .map(function (key) { return key; });
        }

        ReconciliationAssign.save({ transactionId: $routeParams.transactionId, ledgerIds: convertDictionaryToArray($scope.choosenLedgers), amount: $scope.SelectedAmount, contractId: $scope.choosenContract }, function (data) {
            $scope.transaction = data;
            $scope.RemainingAmount = $scope.transaction.RemainingAmount;
            $scope.SelectedAmount = $scope.RemainingAmount;
            if ($scope.transaction.Status !== 'PartiallyAssigned') {
                $scope.back('status', 1);//assigned
            } else {
                $scope.updateFilter();
            }
            $scope.wasSearching = false;
            getTransaction();
        });
    };

    $scope.back = function (key, value) {
        if (key) {
            SharedParameters.setValue(key, value);
        }

        $location.path("/activities/reconciliation");
    };

    $scope.ignore = function (item) {
        Reconciliation.delete({
            transactionId: item.Id,
            setTransactionIgnored: (item.Status === "NotAssigned" || item.Status === "PartiallyAssigned")
        }, function (data) {
            if (data.status === "Ignored" || data.status === "PartiallyIgnored") {
                $scope.back("status", 2); //ignored
            } else {
                item.Status = data.status;
                getTransaction();
            }
        });
    };

    $scope.chooseLedgerChkChange = function (ledgerId, ledgerAmount) {
        if ($scope.choosenLedgers[ledgerId]) {
            $scope.choosenLedgersCount++;
            $scope.choosenLedgersAmount += ledgerAmount;
        } else {
            $scope.choosenLedgersCount--;
            $scope.choosenLedgersAmount -= ledgerAmount;
        }
        $scope.SelectedAmount = $scope.choosenLedgersAmount;
        $scope.choosenContract = '';
    };

    $scope.chooseContractRadioChange = function () {
        $scope.choosenLedgers = [];
        $scope.SelectedAmount = $scope.RemainingAmount;
        $scope.choosenLedgersCount = 0;
        $scope.choosenLedgersAmount = 0;
    };

    $scope.getRemainingAmount = function () {
        return $scope.choosenLedgersCount > 0 ? $scope.RemainingAmount - $scope.SelectedAmount : $scope.RemainingAmount;
    };

    $scope.isLedgerSelectionEnabled = function (ledgerId) {
        if ($scope.choosenLedgersCount > 0 && !$scope.choosenLedgers[ledgerId]) {
            return !$scope.isAmountValid();
        }
        return false;
    };
    
    $scope.onlyAssignedFilter = function (assignment) {
        return assignment.UnassignmentLedgerEntryId === undefined;
    }
 
    $scope.getTransactionDescription = function(transaction) {
        return transaction.Description.replace('Transaction', PUtill.getText('Transaction'));
    };
};
ReconciliationAssignController.$inject = ['$scope', '$routeParams', '$location', 'ReconciliationAssign', 'ReconciliationAssignSearch', 'Reconciliation', 'SharedParameters', 'PUtill'];
